import { render, staticRenderFns } from "./ReviewExceptSetting.vue?vue&type=template&id=e15f522a&scoped=true&"
import script from "./ReviewExceptSetting.vue?vue&type=script&lang=ts&"
export * from "./ReviewExceptSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewExceptSetting.vue?vue&type=style&index=0&id=e15f522a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15f522a",
  null
  
)

export default component.exports